"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionError = exports.InvalidToken = exports.InvalidRequest = exports.InsufficientScope = exports.ErrorResponse = void 0;
class InvalidRequest extends Error {
  code = "invalid_request";
  constructor(message, response) {
    super(message);
    this.response = response;
  }
}
exports.InvalidRequest = InvalidRequest;
class InvalidToken extends Error {
  code = "invalid_token";
  constructor(message, response) {
    super(message);
    this.response = response;
  }
}
exports.InvalidToken = InvalidToken;
class InsufficientScope extends Error {
  code = "insufficient_scope";
  constructor(message, response, attr) {
    super(message);
    this.response = response;
    this.attr = attr;
  }
}
exports.InsufficientScope = InsufficientScope;
class ErrorResponse extends Error {
  constructor(message, path, status) {
    super(message);
    this.path = path;
    this.status = status;
  }
}
exports.ErrorResponse = ErrorResponse;
class SessionError extends Error {}
exports.SessionError = SessionError;
//# sourceMappingURL=error.js.map